export default "__VITE_ASSET__DcMUIERw__"